const anamConfig = {
  audioEncoding: process.env.REACT_APP_ANAM_AUDIO_ENCODING ?? 'pcm_s16le',
  sampleRate: process.env.REACT_APP_ANAM_SAMPLE_RATE ?? 16000,
  channels: process.env.REACT_APP_ANAM_CHANNELS ?? 1,
  videoStreamTimeoutMs: parseInt(
    process.env.REACT_APP_ANAM_VIDEO_STREAM_TIMEOUT_MS ?? 600000
  ), // 10 minutes
  videoStreamRefreshRatio: parseFloat(
    process.env.REACT_APP_ANAM_VIDEO_STREAM_REFRESH_RATIO ?? 0.8
  ),
  // Round trip between handing Anam audio and hearing it spoken back, used to
  // estimate when buffered speech will finish. Chunk durations are exact, so
  // this is the only estimated term — deliberately generous, since clipping
  // the end of a reply is far worse than a moment of extra streaming.
  audioStartLatencyMs: parseInt(
    process.env.REACT_APP_ANAM_AUDIO_START_LATENCY_MS ?? 2000
  ),
  // Safety net only: caps how long a hidden avatar may keep its session open
  // waiting for buffered speech to finish, should the estimate run away. Long
  // enough not to clip a genuinely long reply.
  hiddenTeardownMaxDelayMs: parseInt(
    process.env.REACT_APP_ANAM_HIDDEN_TEARDOWN_MAX_DELAY_MS ?? 120000
  ) // 2 minutes
};

export default anamConfig;
